<div class="card card-profile shadow">
    <div class="row justify-content-center">
        <div class="col-lg-3 order-lg-2">
            <div class="card-profile-image">
                <a href="javascript:void(0)">
                    <img src="assets/img/theme/softdirex.jpg" class="rounded-circle">
                </a>
            </div>
        </div>
    </div>
    <div class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col">
                <div class="card-profile-stats d-flex justify-content-center mt-md-5">
                    <div>
                        <p class="justify-contract">{{ aboutContent }}</p>
                        <span class="heading">{{ aboutTitle }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center">
            <p>
                <a [routerLink]="['/'+privacyPolicyPath]" class="btn btn-sm btn-default mr-4">{{ 'label.privacy-policy'
                    | transloco }}</a>
            </p>
            <p>
                <a [routerLink]="['/'+termConditionsPath]" class="btn btn-sm btn-default mr-4">{{
                    'label.terms-conditions' | transloco }}</a>
            </p>
            <p>
                <a [routerLink]="['/'+termSalesPath]" class="btn btn-sm btn-default mr-4">{{ 'label.terms-sales' |
                    transloco }}</a>
            </p>
            <p>
                <a [routerLink]="['/'+cookiePolicyPath]" class="btn btn-sm btn-default mr-4">{{ 'label.cookie-policy' |
                    transloco }}</a>
            </p>
        </div>
    </div>
</div>